import { useEffect, useState, type FC } from 'react';
import { usePlatformSettings, useWindowWidth } from '@shared/hooks';
import { AgreepmentStep } from '../steps/agreement-step';
import { CodeStep } from '../steps/code-step';
import { PasswordStep } from '../steps/password-step';
import { RepeatStepOne } from '../steps/repeat-step-one';
import { RepeatStepTwo } from '../steps/repeat-step-two';
import { useRegister } from './model';

interface Props {
  openRestore: () => void;
}

export const Register: FC<Props> = ({ openRestore }) => {
  const register = useRegister(openRestore);
  const windowWidth = useWindowWidth();

  const settings = usePlatformSettings();

  const [type, setType] = useState(settings.first_method);

  useEffect(() => {
    setType(settings.first_method);
  }, [settings]);

  const [stepRepeat, setStepRepeat] = useState(1);

  return (
    <>
      {register.step === 1 && <AgreepmentStep model={register} type={type} />}

      {register.step === 2 && (
        <CodeStep
          model={register}
          settings={settings}
          type={type}
          stepRepeat={stepRepeat}
          setStepRepeat={setStepRepeat}
        />
      )}

      {register.step === 2.1 && (
        <RepeatStepOne model={register} settings={settings} windowWidth={windowWidth} type={type} />
      )}

      {register.step === 2.2 && (
        <RepeatStepTwo
          model={register}
          settings={settings}
          windowWidth={windowWidth}
          type={type}
          setType={setType}
        />
      )}

      {register.step === 3 && <PasswordStep model={register} />}
    </>
  );
};
